import { useLocallyStoredFilters } from '@/routes/projectStages/issues/lib/stores/useLocallyStoredFilters.ts'
import { useEffect } from 'react'
import useGetCurrPath from '@/lib/hooks/useGetCurrPath.ts'

export default function useUpdateStageTabHref() {
  const updateTabHref = useLocallyStoredFilters(state => state.updateTabHref)
  const path = useGetCurrPath()

  useEffect(() => {
    // console.log(`updating tab href`, path)
    if (path === '/') return
    // console.log(`updating tab href`, path)
    // console.log(`updating tab href`, path)
    updateTabHref(path)
  }, [path, updateTabHref])
}
